import React from 'react';
import styles from './Loading.module.scss';
import LoadingIcon from '../../assets/icons/loading.svg';
import Logo from '../../assets/icons/flexiiLogo.svg';

const Loading: React.FC = () => {
  return (
    <div className={styles.loading}>
      <img src={Logo} alt="FLEXXI Care" className={styles.logo} />
      <img src={LoadingIcon} alt="Loading" className={styles.spinner} />
    </div>
  );
};

export default Loading;
